import { loadScript } from '../load-strategies/DailyMotionSdkLoader';

export default {
  name: 'dailyMotion',
  loader: loadScript,
};
